module.exports = __webpack_public_path__ + "static/media/review-star.e4747dcb.svg";